import { ErrorMessage, useField } from "formik";
import { useState } from "react";

function InputUpload({
  label,
  required,
  deafultFile = null,
  placeholder = "",
  formik,
  ...props
}) {
  const [field, meta] = useField(props);
  const [file, setFile] = useState(null);
  const RandomNumber = Math.floor(Math.random() * 9999);
  const isAudio = props?.accept?.includes("audio");

  return (
    <div className="inputUpload customInput">
      <label className="label">
        {label}
        {required && <span>*</span>}
      </label>
      <div
        className={`inputUpload-content customcontainer ${
          meta.touched && meta.error ? "is-invalid" : ""
        }`}
      >
        <p className="imageName">
          {!file && !deafultFile ? (
            placeholder
          ) : deafultFile && !file ? (
            !isAudio ? (
              <img src={deafultFile} className="image" />
            ) : (
              <audio controls>
                <source src={deafultFile} type="audio/ogg" />
                <source src={deafultFile} type="audio/mpeg" />
                error
              </audio>
            )
          ) : !isAudio ? (
            <img src={URL.createObjectURL(file)} className="image" />
          ) : (
            <audio controls>
              <source src={URL.createObjectURL(file)} type="audio/ogg" />
              <source src={URL.createObjectURL(file)} type="audio/mpeg" />
              error
            </audio>
          )}
        </p>
        <label htmlFor={"upload" + RandomNumber} className="buttonUpload">
          Browser
        </label>
        <input
          onChange={(e) => {
            setFile(e.target.files[0]);
            formik.setFieldValue(field.name, e.target.files[0]);
          }}
          id={"upload" + RandomNumber}
          {...props}
          name={field.name}
          type="file"
        />
      </div>
      <ErrorMessage component="div" name={field.name} className="error" />
    </div>
  );
}

export default InputUpload;
